export default {
  lang: 'zh-cn',
  app: {
    title: {
      webTitle: '光子易跨境收款 · 合伙人计划',
      footTitle: '光子易跨境收款'
    },
    label: {
      billingCardManagement: '结算卡管理',
      addBillingCard: '新增结算卡',
      bankAccountName: '开户名称',
      bindPhoneNumber: '绑定手机号',
      IDCard: '身份证号',
      bankCard: '银行账号',
      bankAccount: '开户银行',
      myReward: '我的奖励',
      invitationCode: '邀请码',
      myClient: '我的客户',
      productDescription: '产品介绍',
      settlementCard: '结算卡',
      activityRules: '活动规则',
      currentPostion: '当前位置',
      bePartner: '成为合伙人',
      partnerLevel: '合伙人等级',
      goodDawning: '凌晨好',
			goodMorning: '早上好',
			goodForenoon: '上午好',
			goodNoon: '中午好',
			goodAfternoon: '下午好',
			goodEvening: '傍晚好',
			goodNight: '晚上好',
      goodNight1: '夜里好',
      accumulatedBonus: '累计获得奖金 (元)',
      toBeDettledBonus: '待结算奖金 (元)',
      settlementBonus: '已结算奖金 (元)',
      registeredMembers: '已注册会员数',
      numberOfRegisteredMembers: '已入账会员数',
      accumulatedCredits: '累计入账流水 (元)',
      latestBillingDate: '最近结算日期：',
      rewardRecord: '奖励记录',
      rewardAmount: '奖励金额（元）',
      settlementRrecord: '结算记录',
      settlementDate: '结算日期',
      settlementAmount: '结算金额（元）',
      collectionName: '收款名称',
      memberPhone: '会员手机号',
      registerDate: '注册日期',
      recommendedRegistered: '已推荐注册会员数 (人)',
      registeredMember: '已入账会员数（人）',
      distance: '距离',
      stillNeedMember: '还差入账会员{num}人',
      recommendCumulativeAccount: '推荐累计入账流水',
      stillNeed: '还需要',
      supportPlatform: '支持平台',
      registration: '立即注册',
      shutDown: '关闭',
      savePicture: '保存图片',
      cancel: '取消',
      partnerGuidelines: '邀请攻略',
      rewardRuleDescription: '奖励结算说明',
      phoneNumber: '手机号',
      verificationCode: '验证码',
      copyLink: '复制链接'
    },
    validator: {
      nonEmpty: '不能为空',
      noPhone: '请输入手机号'
    },
    options: {
      // 是否入账
      credited: {
        0: '未入账',
        1: '已入账'
      }
    },
    word: {
      submit: '提交',
      click: '点击',
      confirm: '确认',
      bind: '绑定'
    },
    sentence: {
      billingCardManagement: '您好，你已绑定结算卡。',
      addBillingCard: '为了保证您正常收到奖励金款项，请填写您常用的银行卡信息，并确保信息正确无误。',
      bankAccountName: '请输入开户名称',
      bindPhoneNumber: '请输入银行卡绑定的手机号',
      plsPhoneNumber: '请输入手机号',
      plsVerificationCode: '请输入验证码',
      IDCard: '请输入身份证号',
      bankCard: '请输入银行账号',
      bankAccount: '请输入银行名称，如：中国农业银行',
      inviteFriend: '分享好友成为合伙人',
      totalRecordNum: '共{num}笔记录',
      maxLevel: '当前已是最高等级',
      getVerificationCode: '发送验证码',
      reacquire: 's后重发',
      statementOfSettlement: '当月奖励将于次月10号之前结算（节假日顺延）',
      copyLinkSuccess: '复制成功',
      copyLinkFail: '复制失败'
    }
  }
}
